import { cn } from "@/lib/utils";
import { HTMLAttributes } from "react";

interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  animation?: "pulse" | "wave" | "none";
  variant?: "rounded" | "circular" | "rectangular";
}

function Skeleton({
  className,
  animation = "wave",
  variant = "rounded",
  ...props
}: SkeletonProps) {
  const animationClass = {
    pulse: "animate-pulse",
    wave: "animate-shimmer",
    none: "",
  }[animation];

  const variantClass = {
    rounded: "rounded-md",
    circular: "rounded-full",
    rectangular: "rounded-none",
  }[variant];

  return (
    <div
      className={cn("bg-muted/80", animationClass, variantClass, className)}
      {...props}
    />
  );
}

export { Skeleton };
